import React from 'react'
import './Home.css'
const Home = () => {
  return (
      <div className='home-container'>
Home</div>
  )
}

export default Home